import { TranslationType } from '../../util/i18n';
import {
  TypeContext,
  getEcoRating,
  getEmissionData,
  getEmissionFootnotesMap,
  getEngineDescriptionDls,
  getFinalInspectionDate,
  getFuelType,
  getGearbox,
  technicalDataConfigurationForMarkets,
} from '../VehicleTechnicalDataUtils';

import { Characteristics, Consumption, InflateRequestMode } from '@sccs/types';
import { OptionalProductDto } from '../../types/dls/dls-response/ProductDto';
import { type ParsedTechnicalData } from '../VehicleTechnicalDataUtils';

export const technicalDataParserDls = (
  product: OptionalProductDto,
  market: string,
  language: string,
  mode: InflateRequestMode,
  translations: (key: string, dataset?: TranslationType) => string,
) => {
  const getConfiguredTechnicalData = (): Partial<ParsedTechnicalData> => {
    const parsedTechnicalData: Partial<ParsedTechnicalData> = {};

    const addIfConfiguredForMarket = (
      key: keyof ParsedTechnicalData,
      getValue: () => ParsedTechnicalData[typeof key],
    ) => {
      if (technicalDataConfigurationForMarkets(key, market, TypeContext.DLS)) {
        const value = getValue();
        if (!value) return;
        if (key === 'engineDescription' || key === 'finalInspectionDate' || key === 'fuelType' || key === 'gearBox') {
          parsedTechnicalData[key] = value as Characteristics;
        }
        if (key === 'emissionData') {
          parsedTechnicalData[key] = value as Consumption[];
        }
        // FIXME: this conversion shouldn't be required. Footnotes are returned as a string by getEmissionFootnotesString
        // but are required as an object here?
        if (key === 'emissionFootnotes' && typeof value === 'string') {
          parsedTechnicalData[key] = value as unknown as Record<string, string>;
        }
      }
    };

    addIfConfiguredForMarket('engineDescription', () => getEngineDescriptionDls(product, translations));
    addIfConfiguredForMarket('fuelType', () => getFuelType(product, TypeContext.DLS));
    addIfConfiguredForMarket('gearBox', () => getGearbox(product, TypeContext.DLS));
    addIfConfiguredForMarket('finalInspectionDate', () => getFinalInspectionDate(product, mode, TypeContext.DLS));
    addIfConfiguredForMarket('ecoRating', () => getEcoRating(product, language));
    addIfConfiguredForMarket('emissionData', () =>
      getEmissionData(product, TypeContext.DLS, language, translations, market),
    );
    addIfConfiguredForMarket('emissionFootnotes', () => getEmissionFootnotesMap(product));
    return parsedTechnicalData;
  };

  return {
    getTechnicalData: getConfiguredTechnicalData,
  };
};
export { ParsedTechnicalData };
